// extracted by mini-css-extract-plugin
export default {"wrapper":"FullScreenWrapper_wrapper__vpek1","close":"FullScreenWrapper_close__RbTbu"};